import React, { useEffect, useState } from "react"

import {
   CommitDepartmentAuditItems,
   GetDepartmentBulkCommitAuditItemsSummary,
} from "api/api.service"
import { Button } from "components/Button"
import { DataTable } from "components/DataTable"
import { Modal } from "components/Modal"
import ConfirmationModal from "pages/Configurator/Trailers/ConfirmationModal"
import toast from "react-hot-toast"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import docIcon from "../../../../assets/images/gyft-icons/paper.png"
import ModalListingSkeleton from "../CountSheetSkeleton/ModalListingSkeleton"

const COLUMNS = {
   SKU_NO: "SKU No.",
   STATION: "Station",
   DATE: "Date",
   TIME: "Time",
   ITEM_NAME: "Item Name",
   AUDIT_QUANTITY: "Audit Quantity",
}
const DepartmentBulkCommitDetailModal = ({
   isOpen,
   toggleFunction,
   selectedItemsData,
   departmentIds,
   request = () => {},
}) => {
   const [modalState, setModalState] = useState(false)
   const [auditHistoryData, setAuditHistoryData] = useState([])
   const [isloading, setIsLoading] = useState(false)

   useEffect(() => {
      setIsLoading(true)
      const payload = {
         itemsIds: selectedItemsData.map(item => item?.itemsId),
         ...(departmentIds.length > 0 && {
            departmentIds: departmentIds.map(id => id),
         }),
      }
      GetDepartmentBulkCommitAuditItemsSummary(payload)
         .then(res => {
            setAuditHistoryData(res?.data)
            setIsLoading(false)
         })
         .catch(err => {
            console.log(err)
         })
   }, [selectedItemsData])

   const handleDepartmentBulkCommit = async () => {
      const payload = {
         itemsIds: selectedItemsData.map(item => item?.itemsId),
         ...(departmentIds.length > 0 && {
            departmentIds: departmentIds.map(id => id),
         }),
      }

      try {
         setIsLoading(true)
         await CommitDepartmentAuditItems(payload)
         toast.success("Stations bulk items has been committed successfully !")
         request()
         toggleFunction()
         handleCloseModal()
      } catch (error) {
         console.log(error)
      } finally {
         setIsLoading(false)
      }
   }

   const handleConfirmationModal = () => {
      setModalState(prev => !prev)
   }
   const handleCloseModal = () => {
      setModalState(false)
   }

   return (
      <>
         <Modal
            isOpen={isOpen}
            handleModalToggling={toggleFunction}
            bodyClassName="px-5"
            customButton={true}
            hideModalHeaderSeparator={true}
            headerClasses="header-container mb-0 pt-5"
            size="lg"
            backdrop="static"
            sizeClasses={"7"}
            scrollable
         >
            {auditHistoryData.length === 0 && !isloading ? (
               <div
                  style={{
                     display: "flex",
                     flexDirection: "column",
                     alignItems: "center",
                     justifyContent: "center",
                     height: "50vh",
                     textAlign: "center",
                     color: "#555",
                  }}
               >
                  <div style={{ marginBottom: "16px" }}>
                     <img
                        src={docIcon}
                        alt="No items"
                        height={"100px"}
                        width={"100px"}
                     />
                  </div>
                  <div
                     style={{
                        fontSize: "14px",
                        color: "black",
                        fontWeight: "bold",
                     }}
                  >
                     No recent audit entries found for selected items.
                  </div>
               </div>
            ) : isloading && !modalState ? (
               <ModalListingSkeleton />
            ) : (
               <div className="mb-5">
                  <div className=" justify-content-end d-flex">
                     <Button
                        isLoading={isloading}
                        title={"Bulk Commit"}
                        type={"submit"}
                        className="list-commit-button mb-3 align-items-center"
                        size={"lg"}
                        onClick={handleConfirmationModal}
                     />
                  </div>

                  <DataTable
                     data={auditHistoryData}
                     tableClasses=""
                     loading={isloading}
                     config={[
                        {
                           title: COLUMNS.SKU_NO,
                           render: item => item?.item?.skuNo,
                        },
                        {
                           title: COLUMNS.ITEM_NAME,
                           render: item => item?.item?.itemName,
                        },
                        {
                           title: COLUMNS.STATION,
                           render: item => item?.department?.departmentName,
                        },
                        {
                           title: COLUMNS.AUDIT_QUANTITY,
                           render: item => item?.newQuantity,
                        },
                        {
                           title: COLUMNS.DATE,
                           render: data =>
                              convertDateTime({
                                 date: data.updatedAt,
                                 customFormat:
                                    dateTimeFormat.casitaCustomDateFormatOnly,
                                 dateOnly: true,
                                 local: true,
                              }),
                        },
                        {
                           title: COLUMNS.TIME,
                           render: data =>
                              convertDateTime({
                                 date: data.updatedAt,
                                 customFormat: dateTimeFormat.onlyTimeFormat,
                                 dateOnly: true,
                                 local: true,
                              }),
                        },
                     ]}
                  />
               </div>
            )}
         </Modal>
         <ConfirmationModal
            isOpen={modalState}
            actionName="Save"
            entityName="Bulk Commit"
            toggleFunction={handleCloseModal}
            handleYes={handleDepartmentBulkCommit}
            isLoading={isloading}
         />
      </>
   )
}

export default DepartmentBulkCommitDetailModal
